// extracted by mini-css-extract-plugin
export default {"mainContainer":"CookiePolicy_mainContainer__Sb1NA","title":"CookiePolicy_title__iCOW+"};